import { useCallback } from 'react';
import { TeamChatTypes } from '@frontend/api-team-chat';
import { InfinitePaginatedList } from '@frontend/components';
import { useTranslation } from '@frontend/i18n';
import { useTeamChatSelector } from '../../../../providers/team-chat.provider/team-chat.provider';
import { ThreadMessage } from '../thread-message/thread-message';

export const ThreadsList = () => {
  const { t } = useTranslation('team-chat');
  const threadsQueryProps = useTeamChatSelector((ctx) => ctx.threadsQueryProps);
  const openThread = useTeamChatSelector((ctx) => ctx.openThread);
  const isNavigatingFromThreads = useTeamChatSelector((ctx) => ctx.isNavigatingFromThreads);
  const setIsNavigatingFromThreads = useTeamChatSelector((ctx) => ctx.setIsNavigatingFromThreads);
  const user = useTeamChatSelector((ctx) => ctx.user);

  const goToMessage = useCallback(
    (parentMessage: TeamChatTypes.Message) => {
      const { channelId, id: parentMessageId } = parentMessage;
      openThread(parentMessageId, channelId);
      if (!isNavigatingFromThreads) {
        setIsNavigatingFromThreads(true, parentMessage);
      }
    },
    [isNavigatingFromThreads, openThread, setIsNavigatingFromThreads]
  );

  return (
    <InfinitePaginatedList
      infiniteQueryProps={threadsQueryProps}
      emptyStateConfig={{
        type: 'threads',
        textProps: { color: 'subdued' },
        header: t('Stay on top of conversations with threads.'),
        description: t('Reply to a message to create your first one and easily track it here.'),
      }}
      renderListItem={({ listItem }) => {
        const { latestReplies, name, parentMessage, replyCount, type, unreadCount } = listItem;

        return (
          <ThreadMessage
            parentMessage={parentMessage}
            channelName={type === 'DM' ? 'DM' : `#${name}`}
            replyCount={replyCount}
            latestReplies={latestReplies}
            onClickThread={goToMessage}
            unreadCount={unreadCount}
            currentUserId={user?.userID}
          />
        );
      }}
    />
  );
};
